import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_REGISTRATION_FIELDS,
} from '@modules/general-settings/submodules/registration-fields/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsRegistrationFieldsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_ROUTE_NAME,
      path: 'registration_fields',

      component: () => import('@modules/general-settings/submodules/registration-fields/pages/AdminGeneralSettingsRegistrationFieldsPage/AdminGeneralSettingsRegistrationFieldsPage.vue'),

      permission: ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_PERMISSIONS.PROJECTSETTINGS_REQUIRED_FIELDS_IN_PROFILE_UPDATE,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_REGISTRATION_FIELDS, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_PERMISSIONS.PROJECTSETTINGS_REQUIRED_FIELDS_IN_PROFILE_UPDATE,
      id: ADMIN_GENERAL_SETTINGS_REGISTRATION_FIELDS_ROUTE_NAME,
      order: 90,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_REGISTRATION_FIELDS, getTranslationKeys);
  }
}
